/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PatchOrdersIdMutationRequest, PatchOrdersIdMutationResponse, PatchOrdersIdPathParams, PatchOrdersId400 } from "../entities/PatchOrdersId";

function getPatchOrdersIdUrl(id: PatchOrdersIdPathParams["id"]) {
  const res = { method: 'PATCH', url: `/orders/${id}` as const }  
  return res
}

/**
 * @description Обновление цены заказа
 * @summary Обновление цены заказа
 * {@link /orders/:id}
 */
export async function patchOrdersId(id: PatchOrdersIdPathParams["id"], data: PatchOrdersIdMutationRequest, config: Partial<RequestConfig<PatchOrdersIdMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PatchOrdersIdMutationResponse, ResponseErrorConfig<PatchOrdersId400>, PatchOrdersIdMutationRequest>({ method : "PATCH", url : getPatchOrdersIdUrl(id).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}